module.exports = __webpack_public_path__ + "./assets/img_ntu_color__eb6665179227a4ce2a6a893653ed5e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ntu_color.jpg
// module id = 594
// module chunks = 12